"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAtprotoAudience = exports.atprotoDidSchema = void 0;
exports.isAtprotoDid = isAtprotoDid;
exports.asAtprotoDid = asAtprotoDid;
exports.assertAtprotoDid = assertAtprotoDid;
exports.assertAtprotoDidWeb = assertAtprotoDidWeb;
exports.isAtprotoDidWeb = isAtprotoDidWeb;
const zod_1 = require("zod");
const did_error_js_1 = require("./did-error.js");
const uri_js_1 = require("./lib/uri.js");
const methods_js_1 = require("./methods.js");
exports.atprotoDidSchema = zod_1.z
    .string()
    .refine(isAtprotoDid, `Atproto only allows "plc" and "web" DID methods`);
function isAtprotoDid(input) {
    // Optimized equivalent of:
    // return isDidPlc(input) || isAtprotoDidWeb(input)
    if (typeof input !== 'string') {
        return false;
    }
    else if (input.startsWith(methods_js_1.DID_PLC_PREFIX)) {
        return (0, methods_js_1.isDidPlc)(input);
    }
    else if (input.startsWith(methods_js_1.DID_WEB_PREFIX)) {
        return isAtprotoDidWeb(input);
    }
    else {
        return false;
    }
}
function asAtprotoDid(input) {
    assertAtprotoDid(input);
    return input;
}
function assertAtprotoDid(input) {
    if (typeof input !== 'string') {
        throw new did_error_js_1.InvalidDidError(typeof input, `DID must be a string`);
    }
    else if (input.startsWith(methods_js_1.DID_PLC_PREFIX)) {
        (0, methods_js_1.assertDidPlc)(input);
    }
    else if (input.startsWith(methods_js_1.DID_WEB_PREFIX)) {
        assertAtprotoDidWeb(input);
    }
    else {
        throw new did_error_js_1.InvalidDidError(input, `Atproto only allows "plc" and "web" DID methods`);
    }
}
function assertAtprotoDidWeb(input) {
    (0, methods_js_1.assertDidWeb)(input);
    if (isDidWebWithPath(input)) {
        throw new did_error_js_1.InvalidDidError(input, `Atproto does not allow path components in Web DIDs`);
    }
    if (isDidWebWithHttpsPort(input)) {
        throw new did_error_js_1.InvalidDidError(input, `Atproto does not allow port numbers in Web DIDs, except for localhost`);
    }
}
/**
 * @see {@link https://atproto.com/specs/did#blessed-did-methods}
 */
function isAtprotoDidWeb(input) {
    if (!(0, methods_js_1.isDidWeb)(input)) {
        return false;
    }
    if (isDidWebWithPath(input)) {
        return false;
    }
    if (isDidWebWithHttpsPort(input)) {
        return false;
    }
    return true;
}
function isDidWebWithPath(did) {
    return did.includes(':', methods_js_1.DID_WEB_PREFIX.length);
}
function isLocalhostDid(did) {
    return (did === 'did:web:localhost' ||
        did.startsWith('did:web:localhost:') ||
        did.startsWith('did:web:localhost%3A'));
}
function isDidWebWithHttpsPort(did) {
    if (isLocalhostDid(did))
        return false;
    const pathIdx = did.indexOf(':', methods_js_1.DID_WEB_PREFIX.length);
    const hasPort = pathIdx === -1
        ? // No path component, check if there's a port separator anywhere after
            // the "did:web:" prefix
            did.includes('%3A', methods_js_1.DID_WEB_PREFIX.length)
        : // There is a path component; if there is an encoded colon *before* it,
            // then there is a port number
            did.lastIndexOf('%3A', pathIdx) !== -1;
    return hasPort;
}
const isAtprotoAudience = (value) => {
    if (typeof value !== 'string')
        return false;
    const hashIndex = value.indexOf('#');
    if (hashIndex === -1)
        return false;
    if (value.indexOf('#', hashIndex + 1) !== -1)
        return false;
    return ((0, uri_js_1.isFragment)(value, hashIndex + 1) && isAtprotoDid(value.slice(0, hashIndex)));
};
exports.isAtprotoAudience = isAtprotoAudience;
//# sourceMappingURL=atproto.js.map